/**
 * Command Center accepts TOTP-backed AAL2 or a passkey-authenticated AAL1 session.
 * Server callers MUST supply claims from a verified access token, never user metadata.
 * Client callers use this only for UI; the API independently verifies the token.
 */
export function hasStrongAuthentication(aal: unknown, authenticationMethods: unknown): boolean {
  if (aal === "aal2") return true
  if (aal !== "aal1" || !Array.isArray(authenticationMethods)) return false
  return authenticationMethods.some(
    (entry: unknown) =>
      entry === "passkey" ||
      (typeof entry === "object" && entry !== null && "method" in entry && entry.method === "passkey"),
  )
}
